export default (state) => {
  state.currentAdministrator.citationsReport.isFetching = false;
};
